import React from "react";
import "./StarRating.css";

const STAR_PATH =
  "M12 2.5l2.94 5.96 6.58.96-4.76 4.64 1.12 6.55L12 17.52l-5.88 3.09 1.12-6.55L2.48 9.42l6.58-.96L12 2.5z";

// Read-only stars that can show fractional ratings (e.g. 4.3 → 4 full + 30% star)
export default function StarRating({value = 0, size = 16, className = ""}) {
  return (
    <span
      className={`star-rating ${className}`}
      role="img"
      aria-label={`Rated ${Number(value).toFixed(1)} out of 5`}
    >
      {[0, 1, 2, 3, 4].map((i) => {
        const fill = Math.max(0, Math.min(1, value - i)) * 100;
        return (
          <span key={i} className="star" style={{width: size, height: size}}>
            <svg viewBox="0 0 24 24" className="star-empty" aria-hidden="true">
              <path d={STAR_PATH} />
            </svg>
            <span className="star-fill" style={{width: `${fill}%`}}>
              <svg viewBox="0 0 24 24" style={{width: size, height: size}} aria-hidden="true">
                <path d={STAR_PATH} />
              </svg>
            </span>
          </span>
        );
      })}
    </span>
  );
}

const INPUT_LABELS = ["", "Poor", "Fair", "Good", "Very good", "Excellent"];

// Accessible star picker — a radio group, so it works with keyboard arrows
export function StarInput({value, onChange, hover, onHover, size = 30, name = "rating"}) {
  const shown = hover || value;
  return (
    <div className="star-input" onMouseLeave={() => onHover(0)}>
      <div className="star-input-row" role="radiogroup" aria-label="Your rating">
        {[1, 2, 3, 4, 5].map((n) => (
          <label
            key={n}
            className={`star-input-star ${n <= shown ? "on" : ""}`}
            onMouseEnter={() => onHover(n)}
          >
            <input
              type="radio"
              name={name}
              value={n}
              checked={value === n}
              onChange={() => onChange(n)}
              aria-label={`${n} star${n > 1 ? "s" : ""} — ${INPUT_LABELS[n]}`}
            />
            <svg viewBox="0 0 24 24" style={{width: size, height: size}} aria-hidden="true">
              <path d={STAR_PATH} />
            </svg>
          </label>
        ))}
      </div>
      <span className="star-input-label">{INPUT_LABELS[shown] || "Tap to rate"}</span>
    </div>
  );
}
